import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { Contract } from '../generated/types';

export const PROJECT_CONTRACTS_QUERY = gql`
  query ProjectContracts($projectId: ID!) {
    projectContracts(projectId: $projectId) {
      id
      name
      totalValue
      numberOfInstallments
      startDate
      status
      installments {
        id
        number
        amount
        dueDate
        status
        paidAt
      }
      users {
        id
        fullName
        email
      }
      createdAt
      updatedAt
    }
  }
`;

export function useProjectContracts(projectId: string) {
  const { data, loading, error, refetch } = useQuery<{ projectContracts: Contract[] }>(PROJECT_CONTRACTS_QUERY, {
    variables: { projectId },
  });

  const contracts: Contract[] = data?.projectContracts ?? [];

  return { contracts, loading, error, refetch };
}
